"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _intlI18n = require("@/i18n/intl-i18n");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'NewsCard',
  mixins: [_intlI18n.intlMixin],
  props: {
    news: {
      type: Object,
      required: true
    }
  },
  computed: {
    // 从 "2026.09.08" 提取日和月
    dayStr: function dayStr() {
      var parts = (this.news.date || '').split('.');
      return parts[2] || '';
    },
    monthStr: function monthStr() {
      var parts = (this.news.date || '').split('.');
      var m = parts[1] || '';
      var monthNames = {
        '01': 'JAN',
        '02': 'FEB',
        '03': 'MAR',
        '04': 'APR',
        '05': 'MAY',
        '06': 'JUN',
        '07': 'JUL',
        '08': 'AUG',
        '09': 'SEP',
        '10': 'OCT',
        '11': 'NOV',
        '12': 'DEC'
      };
      return monthNames[m] || m;
    },
    newsTitle: function newsTitle() {
      return this.news.title || '';
    },
    newsSummary: function newsSummary() {
      return this.news.summary || '';
    }
  }
};